export enum Roles {
  Master = 'master',
  Owner = 'owner',
  Spectator = 'spec',
}
